import React from 'react';
import ColumnName from '@/util/ColumnName';
import ForeignKey from '@/util/ForeignKey';

import ColumnRenderer from '../util/ColumnRenderer';

type Value = ColumnName | ForeignKey;
export type ColumnsSelectorProps = {
  values: Value[];
  selectedValue?: Value;
  renderer: ColumnRenderer;
};

const ColumnsSelector: React.FC<ColumnsSelectorProps> = ({
  values,
  selectedValue,
  renderer,
}) => {
  const keys: string[] = renderer.keys();
  const centered: boolean = renderer.textAlignCenter();

  // group values into keys
  const valuesByKey = keys.reduce((result, key) => {
    result[key] = [];
    return result;
  }, {} as Record<string, Value[]>);

  values.forEach((value) => {
    const key = renderer.valueToKeyMapper(value);
    const group = valuesByKey[key];
    if (!group) {
      window.console.error(`key not found:${key}`);
    }
    group.push(value); // NOTE: if group is null, it is because the valueToKeyMapper returned an unexpected key
  });

  // sort each list
  keys.forEach((key: string) => {
    valuesByKey[key] = valuesByKey[key].sort(renderer.valueSortFunc);
  });

  // now render the panels
  const panels = keys.map((key: string) => {
    const options = valuesByKey[key].map((value, index) => {
      const className = `list-group-item hide-overflow${
        value === selectedValue ? 'active' : ''
      }`;
      const onClick = (e: React.MouseEvent) => {
        e.preventDefault();
        renderer.optionClicked(value)();
      };
      return (
        <a key={index} href="#" className={className} onClick={onClick}>
          {renderer.renderValue(value)}
        </a>
      );
    });
    if (options.length === 0) {
      return null;
    }
    let headingClassName = 'card-header border-0';
    let listGroupClassName = 'list-group border-0 rounded-0';
    if (centered) {
      headingClassName += ' text-align-center';
      listGroupClassName += ' text-align-center';
    } else {
      headingClassName += ' text-align-right';
    }
    return (
      <div key={key} className="card">
        <div className={headingClassName}>{renderer.renderKey(key)}</div>
        <div className={listGroupClassName}>{options}</div>
      </div>
    );
  });
  return <div>{panels}</div>;
};

export default ColumnsSelector;
